import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem
} from "../basic/sidebar";
import {ArrowLeft, Building2, LogOut, Package, Shield, ShoppingBag, Users} from "lucide-react";
import {useTranslationWithKeys} from "../../hooks/useTranslationWithKeys";
import polysunLogo from "../../assets/Polysun-Software-Icon.svg";
import {Button} from "../basic/button";

interface AdminSidebarProps {
  location: any;
  navigate: (path: string) => void;
  onExitAdminMode: () => void;
  onLogout: () => void;
}

export function AdminSidebar({ location, navigate, onExitAdminMode, onLogout }: AdminSidebarProps) {
  const {t} = useTranslationWithKeys();
  
  const adminMenuItems = [
    {id: "/admin/users", label: t('admin.users.title'), icon: Users},
    {id: "/admin/licenses", label: t('admin.licenses.title'), icon: Package},
    {id: "/admin/teams", label: t('admin.teams.title'), icon: Building2},
    {id: "/admin/products", label: t('admin.products.title'), icon: ShoppingBag},
  ];

  return (
    <Sidebar variant="sidebar" collapsible="offcanvas" className="z-50">
      <SidebarHeader className="border-b p-4">
        <div className="flex items-center gap-2 mb-4">
          <img src={polysunLogo} alt="Polysun" className="h-8 w-8"/>
          <div className="flex-1">
            <p>{t('admin.adminPanel')}</p>
            <p className="text-muted-foreground">{t('admin.systemManagement')}</p>
          </div>
        </div>
        <div className="bg-accent/50 rounded-lg p-3">
          <div className="flex items-center gap-2">
            <Shield className="h-4 w-4 text-primary" />
            <p className="text-primary">{t('admin.modeActive')}</p>
          </div>
        </div>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>{t('admin.menu')}</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {adminMenuItems.map((item) => (
                <SidebarMenuItem key={item.id}>
                  <SidebarMenuButton
                    onClick={() => navigate(item.id)}
                    isActive={location.pathname === item.id}
                  >
                    <item.icon className="h-4 w-4" />
                    <span>{item.label}</span>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter className="border-t p-4">
        <Button
            variant="ghost"
            className="flex items-center gap-2 w-full justify-start px-3 py-2 mb-3"
          onClick={onExitAdminMode}
        >
          <ArrowLeft className="h-4 w-4" />
          <span>{t('admin.backToPortal')}</span>
        </Button>
        <Button
            variant="ghost"
            className="flex items-center gap-2 w-full justify-start px-3 py-2"
          onClick={onLogout}
        >
          <LogOut className="h-4 w-4" />
          <span>{t('sidebar.signOut')}</span>
        </Button>
      </SidebarFooter>
    </Sidebar>
  );
}